import React from 'react';
import { motion } from 'framer-motion';
import './AboutValuesSection.css';
import aboutvalue from "../../Assets/about/aboutvalue.png"
import vectorline from "../../Assets/about/vectorline.png"

const AboutValuesSection = () => {
  return (
    <section className="about-values-section">
      <motion.h2
        className="about-values-heading"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {/* Our Mission, Vision & Values */}
      </motion.h2>

      <div className="about-values-content">
        <motion.div
          className="value-block"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h3>VCNR Enterprise - Vision 2030</h3>
          <p>
          To become a world-class, trusted enterprise by 2030, one that builds scalable and sustainable businesses, creates lasting value, enriches lives, and delivers exceptional experiences at every touchpoint.
          </p>
        </motion.div>

        {/* <motion.div
          className="value-block"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: true }}
        >
          <h3>Mission</h3>
          <p>
            To be India’s most respected and impactful business group — transforming industries through purpose-driven innovation, leadership, and lasting value.
          </p>
        </motion.div> */}
      </div>

      <motion.div
        className="about-values-image-wrapper"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true }}
      >
        <img
          src={aboutvalue}
          alt="Man with light on cliff"
          className="about-values-image"
        />
      </motion.div>
      <img
          src={vectorline}
          alt="vectorline"
          className="about-vector-image"
        />
    </section>
  );
};

export default AboutValuesSection;
